/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerCreateMutationRequest, ApplicationsControllerCreateMutationResponse, ApplicationsControllerCreate400, ApplicationsControllerCreate401, ApplicationsControllerCreate403 } from "../../models/checklistsController/ApplicationsControllerCreate";

function getApplicationsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-applications` as const }  
  return res
}

/**
 * @description Create one or more checklist applications. Accepts either a single application object or an array of applications. When creating multiple applications, each is independent with its own template and scopes. All operations are atomic - if any application fails validation, none are created.
 * @summary Create checklist application(s)
 * {@link /api/v1/checklist-applications}
 */
export async function applicationsControllerCreate(data?: ApplicationsControllerCreateMutationRequest, config: Partial<RequestConfig<ApplicationsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ApplicationsControllerCreateMutationResponse, ResponseErrorConfig<ApplicationsControllerCreate400 | ApplicationsControllerCreate401 | ApplicationsControllerCreate403>, ApplicationsControllerCreateMutationRequest>({ method : "POST", url : getApplicationsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}